
document.addEventListener("DOMContentLoaded", function () {
    "use strict";

    /* -------------------------------------------

    Swup

    ------------------------------------------- */

    const swup = new Swup({
        containers: ['#swup', '#swupMenu', '#swup-opm'],
        animateHistoryBrowsing: true,
    });

    /* -------------------------------------------

    register gsap plugins

    ------------------------------------------- */
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);
    /* -------------------------------------------

    ScrollSmoother

    ------------------------------------------- */
    ScrollSmoother.create({
        smooth: 1,
        effects: true,
        smoothTouch: 0.1,
    });

    /* -------------------------------------------

    cursor parallax

    ------------------------------------------- */
    var scene1 = document.getElementById('scene');
    if (scene1) {
        var parallaxInstance1 = new Parallax(scene1, {
            limitY: 10,
        });
    }

    var scene2 = document.getElementById('scene-2');
    if (scene2) {
        var parallaxInstance2 = new Parallax(scene2, {
            limitY: 10,
        });
    }
    /* -------------------------------------------

    menu

    ------------------------------------------- */
    document.addEventListener('click', function (event) {
        const menuBtn = event.target.closest('.sm-menu-btn');
        const menuFrame = document.querySelector('.sm-menu-frame');
        const btnFrame = document.querySelector('.sm-buttons-tp-frame');
        const tp2 = document.querySelector('.sm-top-panel-2');

        if (menuBtn) {
            menuBtn.classList.toggle('sm-active');
            menuFrame.classList.toggle('sm-active');
            btnFrame.classList.toggle('sm-active');
            tp2.classList.toggle('sm-menu-open');
        } else if (event.target.closest('.sm-menu-frame') && !event.target.closest('.sm-menu-frame > *')) {
            menuFrame.classList.remove('sm-active');
            btnFrame.classList.remove('sm-active');
            document.querySelector('.sm-menu-btn').classList.remove('sm-active');
            tp2.classList.remove('sm-menu-open');
        }
    });

    document.querySelectorAll('.sm-main-menu li a').forEach(link => {
        link.addEventListener('click', function (event) {
            const href = this.getAttribute('href');

            if (isValidHref(href)) {
                document.querySelector('.sm-menu-btn').classList.remove('sm-active');
                document.querySelector('.sm-menu-frame').classList.remove('sm-active');
                document.querySelector('.sm-buttons-tp-frame').classList.remove('sm-active');
                document.querySelector('.sm-top-panel-2').classList.remove('sm-menu-open');
            } else {
                event.preventDefault();
            }
        });
    });

    function isValidHref(href) {
        return href && href.trim() !== '' && href.length > 1 && !/^#(\.|$)/.test(href);
    }

    document.querySelectorAll('.sm-has-children > a').forEach(link => {
        link.addEventListener('click', function (event) {
            event.stopPropagation();
            event.preventDefault(); // Додаємо, щоб уникнути переходу за посиланням

            const parentElement = link.parentElement;
            const isActive = parentElement.classList.contains('sm-active');

            document.querySelectorAll('.sm-has-children').forEach(el => {
                const ul = el.querySelector('ul');
                el.classList.remove('sm-active');
                if (ul) ul.style.maxHeight = '0';
            });

            if (!isActive) {
                parentElement.classList.add('sm-active');
                const ul = parentElement.querySelector('ul');
                if (ul) ul.style.maxHeight = `${ul.scrollHeight}px`;
            }
        });
    });

    let lastScrollTop = 0;

    window.addEventListener('scroll', () => {
        const topPanel = document.querySelector('.sm-top-panel-2');
        const menuFrame = document.querySelector('.sm-menu-frame-2');
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (menuFrame.classList.contains('sm-active')) {
            return; // Stop execution if .sm-active class is present
        }

        if (scrollTop > lastScrollTop) {
            topPanel.classList.add('sm-scroll');
        } else if (scrollTop < lastScrollTop && scrollTop === 0) {
            topPanel.classList.remove('sm-scroll');
        }

        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });


    /* -------------------------------------------

    onepage navigation

    ------------------------------------------- */
    document.querySelectorAll('.sm-onepage-nav > li > a, .sm-scroll-to').forEach(link => {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            if (!targetElement) return;

            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            const currentPosition = window.pageYOffset;
            const distance = Math.abs(targetPosition - currentPosition);
            const baseDuration = 0.1; // Base duration in seconds
            const duration = baseDuration + (distance / 4000); // Adjust this factor as needed

            const offsetY = window.innerWidth < 992 ? 120 : 160;
            gsap.to(window, {
                duration: duration,
                ease: 'sine',
                scrollTo: {
                    y: targetElement,
                    offsetY: offsetY
                }
            });
        });
    });

    /* -------------------------------------------

    scrollbar

    ------------------------------------------- */
    gsap.to('.sm-progress', {
        height: '100%',
        ease: 'sine',
        scrollTrigger: {
            scrub: 0.3
        }
    });

    /* -------------------------------------------

    ruber letters

    ------------------------------------------- */
    const headings = document.querySelectorAll('.sm-rubber');

    headings.forEach(heading => {
        const textNodes = [];

        heading.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                node.textContent.split(' ').forEach((word, index, array) => {
                    const wordSpan = document.createElement('span');
                    wordSpan.classList.add('sm-word-span');
                    word.split('').forEach(letter => {
                        const letterSpan = document.createElement('span');
                        letterSpan.classList.add('sm-letter-span');
                        letterSpan.textContent = letter;
                        wordSpan.appendChild(letterSpan);
                    });
                    textNodes.push(wordSpan);
                    if (index < array.length - 1) {
                        textNodes.push(document.createTextNode(' '));
                    }
                });
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                textNodes.push(node.cloneNode(true));
            }
        });

        heading.innerHTML = '';
        textNodes.forEach(node => heading.appendChild(node));

        const letters = heading.querySelectorAll('.sm-letter-span');
        letters.forEach(letter => {
            letter.addEventListener('mouseenter', () => {
                gsap.to(letter, {
                    scaleY: 1.1,
                    y: '-5%',
                    duration: 0.2,
                    ease: 'sine'
                });
            });

            letter.addEventListener('mouseleave', () => {
                gsap.to(letter, {
                    scaleY: 1,
                    y: '0%',
                    duration: 0.2,
                    ease: 'sine'
                });
            });
        });
    });

    /* -------------------------------------------

    counters

    ------------------------------------------- */
    const numbers = document.querySelectorAll(".sm-counter");

    if (numbers.length > 0) {
        numbers.forEach(element => {
            const zero = {
                val: 0
            };
            const num = parseFloat(element.dataset.number);
            const split = num.toString().split(".");
            const decimals = split.length > 1 ? split[1].length : 0;

            gsap.to(zero, {
                val: num,
                duration: 1.8,
                scrollTrigger: {
                    trigger: element,
                    toggleActions: 'play none none reverse',
                },
                onUpdate: function () {
                    element.textContent = zero.val.toFixed(decimals);
                }
            });
        });
    }

    /* -------------------------------------------

    scroll animation

    ------------------------------------------- */
    const appearance = document.querySelectorAll(".sm-up");
    appearance.forEach((section) => {
        gsap.fromTo(section, {
            opacity: 0,
            y: 40,
            scale: 1.04,
            ease: 'sine',
        }, {
            y: 0,
            opacity: 1,
            scale: 1,
            scrollTrigger: {
                trigger: section,
                toggleActions: 'play none none reverse',
            }
        });
    });

    /* -------------------------------------------

    parallax animation

    ------------------------------------------- */

    const parallaxImages = document.querySelectorAll(".sm-parallax-img");

    parallaxImages.forEach((section) => {
        var value1 = section.getAttribute("data-value-1");
        var value2 = section.getAttribute("data-value-2");

        gsap.fromTo(section, {
            ease: 'sine',
            y: value1
        }, {
            y: value2,
            scrollTrigger: {
                trigger: section,
                scrub: true,
                toggleActions: 'play none none reverse'
            }
        });
    });

    /* -------------------------------------------

    parallax x animation

    ------------------------------------------- */

    const parallaxXImages = document.querySelectorAll(".sm-parallax-x-img");

    parallaxXImages.forEach((section) => {
        var value1 = section.getAttribute("data-value-1");
        var value2 = section.getAttribute("data-value-2");

        gsap.fromTo(section, {
            ease: 'sine',
            x: value1
        }, {
            x: value2,
            scrollTrigger: {
                trigger: section,
                scrub: true,
                toggleActions: 'play none none reverse'
            }
        });
    });


    /* -------------------------------------------

    scale animation

    ------------------------------------------- */
    const scaleImage = document.querySelectorAll(".sm-scale-img");

    scaleImage.forEach((section) => {
        var value1 = section.getAttribute("data-value-1");
        var value2 = section.getAttribute("data-value-2");

        if (window.innerWidth < 1200) {
            value1 = Math.max(.95, value1);
        }

        gsap.fromTo(section, {
            ease: 'sine',
            scale: value1,
        }, {
            scale: value2,
            scrollTrigger: {
                trigger: section,
                scrub: true,
                toggleActions: 'play none none reverse',
            }
        });
    });

    /* -------------------------------------------

    rotate animation

    ------------------------------------------- */
    const rotate = document.querySelectorAll(".sm-rotate");

    rotate.forEach((section) => {
        var value = section.getAttribute("data-value");
        gsap.fromTo(section, {
            ease: 'sine',
            rotate: 0,
        }, {
            rotate: value,
            scrollTrigger: {
                trigger: section,
                scrub: true,
                toggleActions: 'play none none reverse',
            }
        });
    });

    /* -------------------------------------------

    add class

    ------------------------------------------- */
    function addClassToElement(element) {
        if (element) {
            element.classList.add('sm-added');
        }
    }

    function removeClassFromElement(element) {
        if (element) {
            element.classList.remove('sm-added');
        }
    }

    document.querySelectorAll('.sm-add-class').forEach(element => {
        ScrollTrigger.create({
            trigger: element,
            toggleActions: 'play none none reverse',
            onEnter: () => addClassToElement(element),
            onLeaveBack: () => removeClassFromElement(element)
        });
    });

    /* -------------------------------------------

    lightbox

    ------------------------------------------- */



    /* ----------------------------------------------------------------------------
    -------------------------------------------------------------------------------

    reinit

    -------------------------------------------------------------------------------
    ---------------------------------------------------------------------------- */

    swup.hooks.on('page:view', () => {

        /* -------------------------------------------

        register gsap plugins

        ------------------------------------------- */
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);
        /* -------------------------------------------

        ScrollSmoother

        ------------------------------------------- */
        ScrollSmoother.create({
            smooth: 1,
            effects: true,
            smoothTouch: 0.1,
        });

        /* -------------------------------------------

        menu

        ------------------------------------------- */

        document.querySelectorAll('.sm-main-menu li a').forEach(link => {
            link.addEventListener('click', function (event) {
                const href = this.getAttribute('href');

                if (isValidHref(href)) {
                    document.querySelector('.sm-menu-btn').classList.remove('sm-active');
                    document.querySelector('.sm-menu-frame').classList.remove('sm-active');
                    document.querySelector('.sm-buttons-tp-frame').classList.remove('sm-active');
                    document.querySelector('.sm-top-panel-2').classList.remove('sm-menu-open');
                } else {
                    event.preventDefault(); // Якщо href невалідний, зупиняємо дію за замовчуванням
                }
            });
        });

        function isValidHref(href) {
            return href && href.trim() !== '' && href.length > 1 && !/^#(\.|$)/.test(href);
        }

        document.querySelectorAll('.sm-has-children > a').forEach(link => {
            link.addEventListener('click', function (event) {
                event.stopPropagation();
                event.preventDefault(); // Додаємо, щоб уникнути переходу за посиланням

                const parentElement = link.parentElement;
                const isActive = parentElement.classList.contains('sm-active');

                document.querySelectorAll('.sm-has-children').forEach(el => {
                    const ul = el.querySelector('ul');
                    el.classList.remove('sm-active');
                    if (ul) ul.style.maxHeight = '0';
                });

                if (!isActive) {
                    parentElement.classList.add('sm-active');
                    const ul = parentElement.querySelector('ul');
                    if (ul) ul.style.maxHeight = `${ul.scrollHeight}px`;
                }
            });
        });
        /* -------------------------------------------

        onepage navigation

        ------------------------------------------- */
        document.querySelectorAll('.sm-onepage-nav > li > a, .sm-scroll-to').forEach(link => {
            link.addEventListener('click', function (event) {
                event.preventDefault();
                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);
                if (!targetElement) return;

                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const currentPosition = window.pageYOffset;
                const distance = Math.abs(targetPosition - currentPosition);
                const baseDuration = 0.1; // Base duration in seconds
                const duration = baseDuration + (distance / 4000); // Adjust this factor as needed

                const offsetY = window.innerWidth < 992 ? 120 : 160;
                gsap.to(window, {
                    duration: duration,
                    ease: 'sine',
                    scrollTo: {
                        y: targetElement,
                        offsetY: offsetY
                    }
                });
            });
        });

        /* -------------------------------------------

        ruber letters

        ------------------------------------------- */
        const headings = document.querySelectorAll('.sm-rubber');

        headings.forEach(heading => {
            const textNodes = [];

            heading.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    node.textContent.split(' ').forEach((word, index, array) => {
                        const wordSpan = document.createElement('span');
                        wordSpan.classList.add('sm-word-span');
                        word.split('').forEach(letter => {
                            const letterSpan = document.createElement('span');
                            letterSpan.classList.add('sm-letter-span');
                            letterSpan.textContent = letter;
                            wordSpan.appendChild(letterSpan);
                        });
                        textNodes.push(wordSpan);
                        if (index < array.length - 1) {
                            textNodes.push(document.createTextNode(' '));
                        }
                    });
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    textNodes.push(node.cloneNode(true));
                }
            });

            heading.innerHTML = '';
            textNodes.forEach(node => heading.appendChild(node));

            const letters = heading.querySelectorAll('.sm-letter-span');
            letters.forEach(letter => {
                letter.addEventListener('mouseenter', () => {
                    gsap.to(letter, {
                        scaleY: 1.1,
                        y: '-5%',
                        duration: 0.2,
                        ease: 'sine'
                    });
                });

                letter.addEventListener('mouseleave', () => {
                    gsap.to(letter, {
                        scaleY: 1,
                        y: '0%',
                        duration: 0.2,
                        ease: 'sine'
                    });
                });
            });
        });


        /* -------------------------------------------

        counters

        ------------------------------------------- */
        const numbers = document.querySelectorAll(".sm-counter");

        if (numbers.length > 0) {
            numbers.forEach(element => {
                const zero = {
                    val: 0
                };
                const num = parseFloat(element.dataset.number);
                const split = num.toString().split(".");
                const decimals = split.length > 1 ? split[1].length : 0;

                gsap.to(zero, {
                    val: num,
                    duration: 1.8,
                    scrollTrigger: {
                        trigger: element,
                        toggleActions: 'play none none reverse',
                    },
                    onUpdate: function () {
                        element.textContent = zero.val.toFixed(decimals);
                    }
                });
            });
        }

        /* -------------------------------------------

        scroll animation

        ------------------------------------------- */
        const appearance = document.querySelectorAll(".sm-up");
        appearance.forEach((section) => {
            gsap.fromTo(section, {
                opacity: 0,
                y: 40,
                scale: 1.04,
                ease: 'sine',
            }, {
                y: 0,
                opacity: 1,
                scale: 1,
                scrollTrigger: {
                    trigger: section,
                    toggleActions: 'play none none reverse',
                }
            });
        });

        /* -------------------------------------------

        parallax animation

        ------------------------------------------- */

        const parallaxImages = document.querySelectorAll(".sm-parallax-img");

        parallaxImages.forEach((section) => {
            var value1 = section.getAttribute("data-value-1");
            var value2 = section.getAttribute("data-value-2");

            gsap.fromTo(section, {
                ease: 'sine',
                y: value1
            }, {
                y: value2,
                scrollTrigger: {
                    trigger: section,
                    scrub: true,
                    toggleActions: 'play none none reverse'
                }
            });
        });

        /* -------------------------------------------

        parallax x animation

        ------------------------------------------- */

        const parallaxXImages = document.querySelectorAll(".sm-parallax-x-img");

        parallaxXImages.forEach((section) => {
            var value1 = section.getAttribute("data-value-1");
            var value2 = section.getAttribute("data-value-2");

            gsap.fromTo(section, {
                ease: 'sine',
                x: value1
            }, {
                x: value2,
                scrollTrigger: {
                    trigger: section,
                    scrub: true,
                    toggleActions: 'play none none reverse'
                }
            });
        });


        /* -------------------------------------------

        scale animation

        ------------------------------------------- */
        const scaleImage = document.querySelectorAll(".sm-scale-img");

        scaleImage.forEach((section) => {
            var value1 = section.getAttribute("data-value-1");
            var value2 = section.getAttribute("data-value-2");

            if (window.innerWidth < 1200) {
                value1 = Math.max(.95, value1);
            }

            gsap.fromTo(section, {
                ease: 'sine',
                scale: value1,
            }, {
                scale: value2,
                scrollTrigger: {
                    trigger: section,
                    scrub: true,
                    toggleActions: 'play none none reverse',
                }
            });
        });

        /* -------------------------------------------

        rotate animation

        ------------------------------------------- */
        const rotate = document.querySelectorAll(".sm-rotate");

        rotate.forEach((section) => {
            var value = section.getAttribute("data-value");
            gsap.fromTo(section, {
                ease: 'sine',
                rotate: 0,
            }, {
                rotate: value,
                scrollTrigger: {
                    trigger: section,
                    scrub: true,
                    toggleActions: 'play none none reverse',
                }
            });
        });

        /* -------------------------------------------

        add class

        ------------------------------------------- */
        function addClassToElement(element) {
            if (element) {
                element.classList.add('sm-added');
            }
        }

        function removeClassFromElement(element) {
            if (element) {
                element.classList.remove('sm-added');
            }
        }

        document.querySelectorAll('.sm-add-class').forEach(element => {
            ScrollTrigger.create({
                trigger: element,
                toggleActions: 'play none none reverse',
                onEnter: () => addClassToElement(element),
                onLeaveBack: () => removeClassFromElement(element)
            });
        });
    });

});


(function($) {
    'use strict';

    $(document).ready(function () {
        /* -------------------------------------------

        Contact

        ------------------------------------------- */

        $('#contact-form').validate({
            submitHandler: function (form) {

                $(form).ajaxSubmit({
                    beforeSubmit: function (text) {
                        $('.sending').show();
                    },
                    success: function (text) {
                        $('.sending').hide();
                        if (text.response === 'success') {
                            $('.ajax-message').removeClass('alert-danger')
                                .addClass('alert-success')
                                .text(text.message)
                                .show();
                            $(form)[0].reset();

                        } else {
                            $('.ajax-message').text(text.message).show();
                        }
                    }
                })
            }
        })
    })
})(jQuery)